// create a reducer for the properties shared between, groups.tsx, groupsList.tsx, groupslistitem, addstudentsSidebarContent.tsxt usign createSlice from redux-toolkit
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { IGradeStudent, StudentsByGrade } from 'src/config/api/models/Grade';
import { NewGroup } from 'src/config/api/models/Group';

export interface IGroupsState {
  currentBookId: string;
  currentBookName: string;
  currentGrade: string;
  currentGroup?: NewGroup;
  currentSelectedStudents: StudentsByGrade[];
  studentList: IGradeStudent[];
}

const initialState: IGroupsState = {
  currentGrade: '',
  currentBookId: '',
  currentBookName: '',
  currentGroup: undefined,
  currentSelectedStudents: [],
  studentList: [],
};

const manageGroupsSlice = createSlice({
  name: 'manageGroups',
  initialState,
  reducers: {
    setCurrentBookId: (state, action: PayloadAction<string>) => {
      state.currentBookId = action.payload;
    },
    setCurrentBookName: (state, action: PayloadAction<string>) => {
      state.currentBookName = action.payload;
    },
    setCurrentGroup: (state, action: PayloadAction<NewGroup | undefined>) => {
      state.currentGroup = action.payload;
    },
    setCurrentSelectedStudents: (state, action: PayloadAction<StudentsByGrade[]>) => {
      state.currentSelectedStudents = action.payload;
    },
    setStudentList: (state, action: PayloadAction<IGradeStudent[]>) => {
      state.studentList = action.payload;
    },
    setCurrentGrade: (state, action: PayloadAction<string>) => {
      state.currentGrade = action.payload;
    },
  },
});

export const {
  setCurrentBookId,
  setCurrentBookName,
  setCurrentGroup,
  setCurrentGrade,
  setCurrentSelectedStudents,
  setStudentList,
} = manageGroupsSlice.actions;

export const { reducer: manageGroupsReducer } = manageGroupsSlice;
